export default __webpack_public_path__ + "static/media/WhitePlus.780688a4.svg";